module.exports = __webpack_public_path__ + "static/media/socket-io.da4b47db.svg";